'use client';

import { userHasRole } from '@/access/roles';
import { DOCUMENTATION_AUDIENCE } from '@/collections/documentation/audience';
import { NavLink } from '@/components/_shared/NavLink';
import { useAuth, useConfig } from '@payloadcms/ui';

const book = (
  <svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true">
    <path
      d="M3 2.6h4.2c.6 0 1.1.5 1.1 1.1v9.7c0-.6-.5-1.1-1.1-1.1H3V2.6Zm10 0H8.8c-.6 0-1.1.5-1.1 1.1v9.7c0-.6.5-1.1 1.1-1.1H13V2.6Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentationNavLink = () => {
  const { user } = useAuth();
  const {
    config: {
      routes: { admin: adminRoute },
    },
  } = useConfig();

  if (!userHasRole(user ?? null, DOCUMENTATION_AUDIENCE)) return null;

  return <NavLink href={`${adminRoute}/documentation`} icon={book} label="Documentation" />;
};
